// extracted by mini-css-extract-plugin
module.exports = {"cardLayout":"Accessory_cardLayout__DubG5","label":"Accessory_label__zQaZ6"};